import {
  SdmMatchConfig,
  Site,
} from "@inrange/building-manager-api-client/models-site";
import { isSiteOwnerOccupied } from "@inrange/theme-components";
import {
  formatCurrency,
  formatPercentage,
} from "@inrange/theme-components/formatting";
import { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import { formatNumber2dp } from "./utils";

const SdmMatchImpactDescription: React.FC<{
  site: Site;
  selectedOffer: SdmMatchConfig;
  isOfferBeingAdded: boolean;
  fetchSiteBuyer: UseQueryResult<{ site: Site }>;
  previewSiteBuyer: UseMutationResult<{ site: Site }>;
  fetchSiteSeller: UseQueryResult<{ site: Site }>;
  previewSiteSeller: UseMutationResult<{ site: Site }>;
}> = ({
  site,
  selectedOffer,
  isOfferBeingAdded,
  fetchSiteBuyer,
  previewSiteBuyer,
  fetchSiteSeller,
  previewSiteSeller,
}) => {
  const getProcurement = (site: Site) => {
    return isSiteOwnerOccupied(site.siteOwnerships) &&
      site.activeInvestmentModel === "license"
      ? site.financialModels.ooLicenseProcurement
      : site.financialModels.procurement;
  };

  const getIrr = (site: Site) => {
    const irrOwnership = isSiteOwnerOccupied(site.siteOwnerships)
      ? "ownerOccupier"
      : "landlord";
    return site.financialModels[irrOwnership]["license"].irr;
  };

  const buyerMessage = (
    <>
      buyer&apos;s savings by{" "}
      {formatCurrency(
        getProcurement(previewSiteBuyer.data!.site).savings -
          getProcurement(fetchSiteBuyer.data!.site).savings,
        previewSiteBuyer.data!.site.currencyCode,
        2,
        false,
        true
      )}{" "}
      (Y1) to{" "}
      <b>
        {formatCurrency(
          getProcurement(previewSiteBuyer.data!.site).savings,
          previewSiteBuyer.data!.site.currencyCode,
          2,
          false
        )}{" "}
        (Y1)
      </b>
    </>
  );
  const sellerMessage = (
    <>
      seller&apos;s IRR by{" "}
      {formatPercentage(
        (getIrr(previewSiteSeller.data!.site) as number) -
          (getIrr(fetchSiteSeller.data!.site) as number),
        2
      )}{" "}
      to{" "}
      <b>
        {formatPercentage(getIrr(previewSiteSeller.data!.site) as number, 2)}
      </b>
    </>
  );

  return (
    <>
      {selectedOffer.buyerId === site.id && (
        <>
          This match will change the {buyerMessage} and the {sellerMessage},{" "}
          {isOfferBeingAdded ? "removing" : "adding"}{" "}
          {formatNumber2dp(selectedOffer.volume)} kWh{" "}
          {isOfferBeingAdded ? "from" : "to"} the buyer&apos;s unmet demand
          excess and the seller&apos;s excess pools.
        </>
      )}
      {selectedOffer.sellerId === site.id && (
        <>
          This match will change the {sellerMessage} and the {buyerMessage},{" "}
          {isOfferBeingAdded ? "removing" : "adding"}{" "}
          {formatNumber2dp(selectedOffer.volume)} kWh{" "}
          {isOfferBeingAdded ? "from" : "to"} the seller&apos;s excess and the
          buyer&apos;s unmet demand pools.
        </>
      )}
    </>
  );
};

export default SdmMatchImpactDescription;
